export const MAP_LEGEND = [
  { name: 'intro_issues', label: 'Blauw', color: '#118DFF' },
  { name: 'contract', label: 'Oranje', color: '#E66C37' },
  { name: 'gotv', label: 'Groen', color: '#009688' }
]
